import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import BrandMark from './BrandMark';
import { neveroverpayApi } from './neveroverpayApi';
import './neveroverpay.css';

export default function NeverOverpayGmailCallback() {
  const navigate = useNavigate();
  const [status, setStatus] = useState('Connecting Gmail…');
  const [error, setError] = useState('');

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const oauthError = params.get('error');
    const code = params.get('code');
    if (oauthError) {
      setError(oauthError);
      return undefined;
    }
    if (!code) {
      setError('Missing Google code. In Settings, the Google redirect must be this page.');
      return undefined;
    }
    let cancelled = false;
    neveroverpayApi.gmailCallback({ code, state: params.get('state') || '' })
      .then(() => {
        if (cancelled) return;
        setStatus('Gmail connected. Continuing…');
        neveroverpayApi.onboarding()
          .then((row) => setTimeout(() => navigate(row?.complete ? '/app' : '/onboarding'), 800))
          .catch(() => setTimeout(() => navigate('/onboarding'), 800));
      })
      .catch((err) => {
        if (!cancelled) setError(err.message || 'Gmail connect failed');
      });
    return () => { cancelled = true; };
  }, [navigate]);

  return (
    <div className="np-root">
      <div className="np-wrap" style={{ paddingTop: 48, maxWidth: 640 }}>
        <BrandMark to="/app" kicker="Gmail" />
        <h1 style={{ fontSize: 28, margin: '24px 0 12px' }}>{error ? 'Could not connect Gmail' : status}</h1>
        {error ? <div className="np-error">{error}</div> : null}
        <p style={{ marginTop: 20 }}><Link className="np-btn ghost" to="/admin">Open settings</Link></p>
      </div>
    </div>
  );
}
